import { api } from "./api";

/* seoApi — admin client for SEO per-route metadata (F6).
   Mirrors testimonialsApi shape: list() returns { items }, upsert() saves one route. */

const BASE = "/seo";

function toUi(r) {
  if (!r) return null;
  return {
    // UI uses `url` as the row key/label; API uses `path`.
    id: r.path,
    url: r.path,
    type: r.type || "static",
    title: r.title || "",
    description: r.description || "",
    ogImage: r.ogImage || "",
    keywords: Array.isArray(r.keywords) ? r.keywords : [],
    updatedAt: r.updatedAt ? String(r.updatedAt).slice(0, 10) : "",
  };
}

export const seoApi = {
  async list() {
    const res = await api.get(BASE);
    return (res.items || []).map(toUi);
  },

  // Upsert one route. `page` is a UI row ({ url, title, description, ogImage, type, keywords }).
  async upsert(page) {
    const body = {
      path: page.url,
      type: page.type,
      title: page.title,
      description: page.description,
      ogImage: page.ogImage,
      keywords: page.keywords,
    };
    const res = await api.patch(BASE, body);
    return toUi(res);
  },
};
